import { useTranslation } from 'react-i18next';
import { cloneDeep } from "lodash";
import { useState, useEffect } from "react";
import { Grid, TextField, InputAdornment, makeStyles } from "@material-ui/core";
import { Search } from "@material-ui/icons";

import { getOption } from "../../lib/api/getOptions";

import BasicTabScreenType from "../screenTypes/functional/BasicTabScreenType";

import OpenFilterButton from "../input/OpenFilterButton";
import FilterDialog from "../dialogTypes/FilterDialog";
import FilterConditionPanelLayout from "../layout/FilterConditionPanelLayout";
import AutoFilterForm from "../filter/functional/AutoFilterForm";
import FilterApplyButton from "../input/FilterApplyButton";
import FilterClearButton from "../input/FilterClearButton";
import FilterCancelButton from "../input/FilterCancelButton";

import WeeklyOntimeDeliveryRateKpi from "./WeeklyOntimeDeliveryRateKpi";
import MonthlyOntimeDeliveryRateKpi from "./MonthlyOntimeDeliveryRateKpi";
import SemiannuallyOntimeDeliveryRateKpi from "./SemiannuallyOntimeDeliveryRateKpi";
import YearlyOntimeDeliveryRateKpi from "./YearlyOntimeDeliveryRateKpi";

const useStyle = makeStyles((theme) => ({
    root: {
        paddingTop: "8px",
        width: "120px"
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

function OntimeDeliveryRateKpiTabContent (props) {

    const { tab, onFilterInitialized, onModifyViewSchema, onSearchInitialized } = props;

    switch ( tab ) {

        case "weekly":

            return <WeeklyOntimeDeliveryRateKpi
                onFilterInitialized={onFilterInitialized}
                onSearchInitialized={onSearchInitialized}
                onModifyViewSchema={onModifyViewSchema}
            />;

        case "monthly":

            return <MonthlyOntimeDeliveryRateKpi
                onFilterInitialized={onFilterInitialized} 
                onSearchInitialized={onSearchInitialized}
                onModifyViewSchema={onModifyViewSchema}
            />;

        case "semiannually":

            return <SemiannuallyOntimeDeliveryRateKpi
                onFilterInitialized={onFilterInitialized} 
                onSearchInitialized={onSearchInitialized}
                onModifyViewSchema={onModifyViewSchema}
            />;

        case "yearly":

            return <YearlyOntimeDeliveryRateKpi
                onFilterInitialized={onFilterInitialized} 
                onSearchInitialized={onSearchInitialized}
                onModifyViewSchema={onModifyViewSchema}
            />;

        default:

            return <></>;

    }

}

function OntimeDeliveryRateKpi (props) {

    const classes=useStyle();

    const { t } = useTranslation();

    const [ tab, setTab ] = useState ( "weekly" );

    const [ , setSearch ] = useState ();
    const [ , setSearchVal ] = useState ();
    const [ filter, setFilter ] = useState ();
    const [ filterApplyButton, setFilterApplyButton ] = useState();
    const [ filterValue, setFilterValue ] = useState ();
    const [ showFilter, setShowFilter ] = useState(false);
    const [ viewSchema, setViewSchema ] = useState ();
    const [ , setFilterDialog ] = useState();
    const [ , setForm ] = useState ();
    const [ useFilterDialog, setUseFilterDialog ] = useState(false);
        
    useEffect(() => {

        let mounted = true;

        ( async () => {

            let useFilterDialogOption = await getOption ( "default", "useFilterDialog" );

            if ( mounted ) {

                if ( useFilterDialogOption && ( useFilterDialogOption.toLowerCase () === "true" ) ) {

                    setUseFilterDialog ( true );
    
                } else {
    
                    setUseFilterDialog ( false );
    
                }
    
            }

        } ) ();

        return ( () => {
            mounted = false;
        } );

    }, []);

    const onTabChanged = (tab) => {
        
        setTab ( tab );

    };

    const onModifyViewSchema = ( viewSchema ) => {

        setViewSchema ( viewSchema );

    }

    const closeFilter = () => {

        setShowFilter ( false );

    };

    const toggleOpenFilter = () => {

        setUseFilterDialog ( ( useFilterDialog ) => {

            if ( useFilterDialog ) {

                setFilterDialog ( ( filterDialog ) => {

                    filterDialog.show ();

                    return filterDialog;

                } );


            } else {

                setShowFilter ( ( showFilter ) => ( !showFilter ) );

            }

            return useFilterDialog;

        } );

    };

    const onFilterDialogInitialized = ( dialog ) => {

        setFilterDialog ( dialog );

    };

    const onClearFilter = () => {


        setForm ( ( form ) => {

            form.clear ();
            return form;

        } );

    }

    const onFormInitialized = ( form ) => {

        setForm ( form );

    }

    const onApplyFilter = ( filterValue ) => {

        if ( filterValue ) {

            setFilterValue ( [...filterValue] );

        } else {

            setFilterValue ( () => {

                let newFilterValue = [];

                for ( const column of viewSchema.columns ) {
        
                    if ( column.filter ) {
    
                        newFilterValue.push ( {
    
                            binding: column.name,
                            type: "condition",
                            and: true,
                            condition1: { operator: "", value: "" },
                            condition2: { operator: "", value: "" }
    
                        } );
    
                    }
                }

                return newFilterValue;

            });
        }
        
    }

    const onFilterInitialized = ( filter ) => {

        setFilter ( filter );

    }

    const onFilterApplyButtonInitialized = ( filterApplyButton ) => {

        setFilterApplyButton ( filterApplyButton );

    };

    const onChangeSearch = ( e ) => {

        setSearch ( ( search ) => {

            if ( search ) {

                setSearchVal ( e.target.value );
                search.applySearch ( e.target.value );

            }

            return search;

        } );

    };

    const onSearchInitialized = ( search ) => {

        setSearch ( search );

        setSearchVal ( ( searchVal ) => {

            if ( searchVal ) {

                search.applySearch ( searchVal );
                
            }

            return searchVal;

        } );

    }
        
    return (

        <>
            <BasicTabScreenType
                id="on-time-delivery-rate-kpi"
                tabs={[
                    "weekly",
                    "monthly",
                    "semiannually",
                    "yearly"
                ]}
                tabLabels={[
                    "주별",
                    "월별",
                    "반기별",
                    "년도별"
                ]}
                tabsStyle={{
                    left: 0,
                    margin: "0px",
                    padding:"0px",
                    height: "48px",
                    width: "600px"
                }}
                onTabChanged={onTabChanged}
                value = {tab}
                rightGridItems={
                    [
                        <>
                            <Grid item>
                                <TextField
                                    id={"on-time-delivery-rate-kpi-report-search"}
                                    className={classes.root}
                                    placeholder={t("common.search")}
                                    onChange={ onChangeSearch }
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>                    
                                        )
                                    }}
                                    style={{
                                        bottom: "2px",
                                        width: "120px"                        
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <OpenFilterButton
                                    id={"ontime-delivery-rate-kpi-open-filter-button"}
                                    className="basicCrudScreenOpenFilterButton"
                                    color="primary"
                                    onClick={toggleOpenFilter}
                                    style={{marginTop: "4px"}}
                                />
                                
                            </Grid>

                        </>
                    ]
                }
            >
                <>
                    {
                        useFilterDialog
                        ?
                        (
                            <FilterDialog

                                id={"ontime-delivery-rate-kpi-filter-dialog"}
                                title={t("dialog.title.Filter")}
                                schema={viewSchema}
                                filter={filter}
                                filterValue={filterValue?cloneDeep(filterValue):filterValue}
                                onInitialized={onFilterDialogInitialized}
                                onFormInitialized={onFormInitialized}
                                onApply={onApplyFilter}
                                onClear={onClearFilter}
                                onCancel={closeFilter}
                            />
                        )
                        :
                        (
                            <FilterConditionPanelLayout
                                className="basicCrudScreenFilterPanel"
                                show={showFilter}
                            >

                                <AutoFilterForm
                                    id={"ontime-delivery-rate-kpi-filter-form"}
                                    className="autoFilterForm"
                                    schema={viewSchema}
                                    filterValue={filterValue?cloneDeep(filterValue):filterValue} // object deep copy - 내부에서 객체 멤버가 수정되어 버그 발생
                                    filterApplyButton={filterApplyButton}
                                    onInitialized={onFormInitialized}
                                />
                                {
                                    filter &&
                                    <FilterApplyButton
                                        id={"ontime-delivery-rate-kpi-filter-apply-button"}
                                        className="filterApplyButton"
                                        schema={viewSchema}
                                        filter={filter}
                                        onApply={onApplyFilter}
                                        onInitialized={onFilterApplyButtonInitialized}
                                    />
                                }
                                <FilterClearButton
                                    id={"ontime-delivery-rate-kpi-filter-clear-button"}
                                    className="filterClearButton"
                                    onClear={onClearFilter}
                                />
                                <FilterCancelButton
                                    id={"ontime-delivery-rate-kpi-filter-cancel-button"}
                                    className="filterCancelButton"
                                    onCancel={closeFilter}
                                />                    

                            </FilterConditionPanelLayout>
                        )
                    }

                    <OntimeDeliveryRateKpiTabContent
                        tab={tab}
                        filterValue={filterValue}
                        onFilterInitialized={onFilterInitialized}
                        onSearchInitialized={onSearchInitialized}
                        onModifyViewSchema={onModifyViewSchema}
                    />
                </>
            </BasicTabScreenType>
        </>
        
    );

}

export default OntimeDeliveryRateKpi;
